var MpBaseDocModels = {

    created: function() {},

    mounted: function() {
        this.setInitialPage(parseInt(this.$refs.ssrPaginator.dataset.page));
        this.$refs.ssrPaginator.querySelectorAll('.js-page-item').forEach(this.addDomPage);

        this.init();
    },

    updated: function() {
        if (!this.isInitialized) {
            this.init();
        }
    },

    destroy: function() {
        window.removeEventListener('hashchange', this.onHashChange);
    },

    mixins: [MpPaginator],

    data: function() {
        return {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',

            itemList: [],

            overlay: null,

            isInitialized: false,
        };
    },

    computed : {
        totalResults: function () {
            return this.totalResultsTPL.replace('%s', this.totalItems);
        },
    },

    methods: {

        getDateFromString: function(dateStr) {
            var dateParts = dateStr.split('-');
            return new Date(parseInt(dateParts[0]), parseInt(dateParts[1])-1, parseInt(dateParts[2]));
        },

        addDomItem: function(item) {
            this.itemList.push({
                id: item.getAttribute('data-id'),
                date: item.getAttribute('data-date'),
                category_id: item.getAttribute('data-category-id'),
                category_name: item.getAttribute('data-category-name'),
                category_token: item.getAttribute('data-category-token'),
                title: item.getAttribute('data-title'),
                detail: item.getAttribute('data-detail'),
                token: item.getAttribute('data-token'),
                file_0: item.getAttribute('data-file'),
                uri: item.getAttribute('data-uri'),
                download_label: item.getAttribute('data-download-label')
            });
        },

        onItemsLoaded: function(response) {
            console.log({
                method: 'onItemsLoaded',
                items: response.data.docmodels,
                totalItems: response.data.total,
            });

            if (response.data.result == this.RESPONSE_OK) {
                this.itemList = response.data.docmodels;
                this.totalItems = response.data.total;
                this.updatePaginator(response);
            }

        },

        init: function() {
            if (this.isInitialized) {
                return;
            }

            window.addEventListener('hashchange', this.onHashChange);
            this.onHashChange();

            this.initPaginator();
            this.isInitialized = true;
        },
    },

    filters: {
        categoryLabel: function(categories) {
            const SEPARATOR = ', ';

            if (typeof(categories) === 'string') {
                return categories;
            }

            if (!categories || !categories.length) {
                return '';
            }

            let categoryLabel = categories.reduce(function(prev, curr, index) {
                return prev += SEPARATOR + curr.name;
            }, '');

            return categoryLabel.slice(categoryLabel.indexOf(SEPARATOR) + 2);
        }
    },
};
